import React, { useState, useEffect, useContext } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { PropTypes } from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeftLong,
  faArrowRightLong,
  faEllipsis,
  faDrawPolygon,
} from "@fortawesome/free-solid-svg-icons";
import "../sass/Title.scss";
import Heading from "./Heading";
import { isMobile } from "react-device-detect";
import PickLocation from "./PickLocation";
import { CityContext } from "./context/CityContext";
import { ChoosenDataSet } from "./context/ChoosenDataSet";
import { NewAddDomain } from "./context/NewAddDomain";
import { SelectedDataSet } from "./context/SelectedDataset";
import { LayerContext } from "./context/LayerContext";
import { LoadingContext } from "./context/Loading";
import { LayerAddContext } from "./context/AddedLayer";
import { toast } from "react-toastify";
import { PlayContext } from "./context/PlayContext";

const Title = ({ Label,country, currentCityIndex, locData }) => {
  const { getCity } = useContext(CityContext);
  const [pickLoc, setPickLoc] = useState();
  const { choosenData } = useContext(ChoosenDataSet);
  const { newAddDataSet } = useContext(NewAddDomain);
  const { selectedIdx } = useContext(SelectedDataSet);
  const {selectedDataSet} = useContext(SelectedDataSet);
  const { getLayer } = useContext(LayerContext);
  const { getSelectedDataSet } = useContext(SelectedDataSet);
  const { getSelectedIdx } = useContext(SelectedDataSet);
  const [idx, setIdx] = useState(null)
  const { getLoading } = useContext(LoadingContext);
  const { loadingOn } = useContext(LoadingContext);
  const { layerAdded } = useContext(LayerAddContext);
  const { playOn } = useContext(PlayContext);
  const {getPlay}=useContext(PlayContext);
  // if (choosenData!=undefined && selectedIdx.length>0) {
  //   console.log(choosenData[selectedIdx[0]].name,selectedIdx[0]);
  // }
  useEffect(() => {
    if (choosenData!=undefined && selectedIdx &&  selectedIdx.length > 0) {
      setIdx(selectedIdx[0])
    }
    else if(selectedIdx && selectedIdx.length==0) {
      setIdx(null)
    }
  }, [selectedIdx, choosenData, newAddDataSet])
  // console.log(idx)
  let params = useParams();
  const navigate = useNavigate();

  const currentDomain = params.domain;

  const prevCityIndex =
    (currentCityIndex - 1 + locData.length) % locData.length;
  const prevCity = locData[prevCityIndex].location;
  const prevCityURL = locData[prevCityIndex].locationURL;
  const nextCityIndex =
    (currentCityIndex + 1 + locData.length) % locData.length;
  const nextCity = locData[nextCityIndex].location;
  const nextCityURL = locData[nextCityIndex].locationURL;

  // console.log(locData[prevCityIndex].locationURL, params.domain);
  // console.log(locData);
  const notify = () => toast.warn('Wait...Image is loading', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme:"dark",
  });
  return (
    <div>
    <div className={isMobile ? "Title mobile" : "Title"}>
        <Heading type="H1">{Label }<span className={`${!isMobile?"countryname":"countryname-mob"}`} >{ "("+country+ ")"}</span></Heading>

      {pickLoc && <PickLocation locData={locData} setPickLoc={setPickLoc} />}

      <div style={{ display: "flex" }}>
          <button className="link" onClick={() => {
            if (selectedDataSet && layerAdded == true && playOn==false || selectedDataSet==undefined) {
              // console.log("1")
              getCity(prevCity.toLowerCase());
              getLayer(false);
              getSelectedIdx([]);
              getSelectedDataSet();
              navigate(`/${prevCityURL}/${currentDomain}`)
            }
            else if (playOn == true) {
              getPlay(false);
              getCity(nextCity.toLowerCase());
              getLayer(false);
              getSelectedIdx([]);
              getSelectedDataSet();
              navigate(`/${nextCityURL}/${currentDomain}`)
            }
            else if (selectedDataSet && layerAdded == false) {
              // alert("ghjkl")
              notify();
            }
              
        }} >
          <FontAwesomeIcon icon={faArrowLeftLong} size="lg" />{" "}
          {!isMobile && prevCity}
        </button>

        <div
          className="link"
          onClick={() => {
             if (selectedDataSet && layerAdded == true && playOn==false || selectedDataSet==undefined) {
              setPickLoc(1);
            }
            else if (selectedDataSet && layerAdded == false) {
              // alert("ghjkl")
              notify();
            }
          }}
        >
          <FontAwesomeIcon icon={faEllipsis} size="lg" />
        </div>

          <button onClick={() => {
            if (selectedDataSet && layerAdded == true && playOn==false || selectedDataSet==undefined ) {
              // console.log("1")
              getCity(nextCity.toLowerCase());
              getLayer(false);
              getSelectedIdx([]);
              getSelectedDataSet();
              navigate(`/${nextCityURL}/${currentDomain}`)
            }
            else if (playOn == true) {
              getPlay(false);
              getCity(nextCity.toLowerCase());
              getLayer(false);
              getSelectedIdx([]);
              getSelectedDataSet();
              navigate(`/${nextCityURL}/${currentDomain}`)
            }
            else if (selectedDataSet && layerAdded == false) {
              // alert("ghjkl");
              notify();
            }
        }} className="link">
          {!isMobile && nextCity}{" "}
          <FontAwesomeIcon icon={faArrowRightLong} size="lg" />
        </button>
        {/* <Link to="/new-location" className="btn btn-primary">
          <FontAwesomeIcon icon={faDrawPolygon} size="lg" />{" "}
          {!isMobile && "Mark a location"}
        </Link> */}
      </div>
      
      </div>
      {isMobile && <div className="datasetName">{newAddDataSet == undefined && idx != null ? choosenData[idx].name : newAddDataSet && idx != null ? newAddDataSet[idx].name :
        "You Have Not Selected Any Dataset To View"}</div>}
      </div>
  );
};

Title.propTypes = {
  Label: PropTypes.string,
};

export default Title;
